package ru.it_mozaika.sender.js.application.components.segments


import io.ktor.client.call.*
import mui.material.*
import mui.system.responsive
import mui.system.sx
import react.*

import react.dom.onChange
import ru.it_mozaika.sender.common.models.Property
import ru.it_mozaika.sender.common.models.Rule
import ru.it_mozaika.sender.common.models.Segment
import ru.it_mozaika.sender.common.models.SegmentUpdateRequest
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError
import ru.it_mozaika.sender.js.application.components.StoresSelect
import ru.it_mozaika.sender.js.application.context.RequestResultContext
import ru.it_mozaika.sender.js.application.context.StoreContext
import web.cssom.px


external interface SegmentDialogProps: Props {
    var isOpen: Boolean
    var onClose: () -> Unit
    var id: String?
}

val segmentDialog = FC<SegmentDialogProps> { props ->
    val (name, setName) = useState("")
    val (rule, setRule) = useState(Rule.RuleGroup())
    val (properties, setProperties) = useState(emptyList<Property>())
    val storeContext = useContext(StoreContext)
    val requestResult = useContext(RequestResultContext)
    val (isDisabled, setIsDisabled) = useState(false)


    fun loadProperties(store: String) {
        Http.get("/subscribers/properties", mapOf("store" to store)) { response ->
            response.checkResponseError()?.let {
                return@get
            }
            setProperties(response.body<List<Property>>())
        }
    }

    fun loadSegment(id: String) {
        Http.get("/segments/$id", query = mapOf("id" to id)) { response ->
            val result = response.body<Segment>()
            setName(result.name)
            setRule(result.rules)
            setIsDisabled(true)
        }
    }
    useEffect(storeContext.currentStore) {
        if (storeContext.currentStore != null) {
            loadProperties(storeContext.currentStoreId!!)
        }
    }
    useEffect(props.id) {
        if (props.id != null) {
            loadSegment(props.id!!)
        } else {
            setName("")
            setRule(Rule.RuleGroup())
            setIsDisabled(false)
        }
    }

    Dialog {
        open = props.isOpen
        DialogTitle {
            +if (props.id == null) "Создание нового сегмента" else "Редактирование сегмента"
        }
        DialogContent {
            Stack {
                sx{
                    padding = 5.px
                }
                direction = responsive(StackDirection.column)
                spacing = responsive(3)
                TextField {
                    value = name
                    fullWidth = true
                    disabled = isDisabled
                    id = "new-segment-name-field"
                    label = ReactNode("Название:")
                    this.variant = FormControlVariant.outlined
                    error = name.isBlank()
                    required = true
                    this.onChange = { event ->
                        val value = event.target.asDynamic().value as String
                        setName(value)
                    }
                }
                StoresSelect {
                    disabled = isDisabled
                }
                RuleGroup {
                    this.rule = rule
                    this.onChange = { setRule(it) }
                    this.onAddRule = { isGroup ->
                        setRule {
                            it.copy(
                                rules = it.rules.plus(
                                    if (isGroup) {
                                        Rule.RuleGroup()
                                    } else {
                                        Rule.Segment()
                                    }
                                )
                            )
                        }
                    }
                    this.properties = properties
                    if (props.id != null) {
                        this.id = props.id!!
                    }
                }
            }
        }
        DialogActions {
            Stack {
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Button {
                    variant = ButtonVariant.outlined
                    this.color = ButtonColor.secondary
                    if (props.id == null) {
                        +"Создать"
                    } else {
                        +if (isDisabled) "Редактировать" else "Сохранить изменения"
                    }
                    this.disabled = name.isBlank()
                    this.onClick = {
                        if (props.id == null) {
                            Http.put("/segments", SegmentUpdateRequest(name, rule)) { response ->
                                requestResult.handleRequestRespond(response)
//                                setName("")
//                                setRule(Rule.RuleGroup())
                                props.onClose()
                            }
                        } else {
                            if (isDisabled) {
                                setIsDisabled(false)
                            } else {
                                Http.post(
                                    "/segments/${props.id}",
                                    query = mapOf("id" to props.id!!),
                                    body = SegmentUpdateRequest(name, rule)
                                ) { response ->
                                    requestResult.handleRequestRespond(response)
//                                    setName("")
//                                    setRule(Rule.RuleGroup())
                                    props.onClose()
                                }
                            }
                        }
                    }
                }
                Button {
                    +"Отмена"
                    color = ButtonColor.error
                    variant = ButtonVariant.outlined
                    onClick = {
                        props.onClose()
//                                props.onClose()
                    }
                }
            }
        }
    }
}